module.exports = __webpack_public_path__ + "img/gzh-info.6dff690d.png";